import { render } from "./MySupports.vue?vue&type=template&id=1719ee80"
import script from "./MySupports.vue?vue&type=script&lang=js"
export * from "./MySupports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__